/**
 * Whether Canvas's "project selected" effect must reload the project (clear the selection, load its revisions and
 * configuration again). `selectedProject` is an object: it is replaced not only when another project is picked but
 * also when one of its details changes (the thumbnail fetched a moment after opening, a rename from the Dashboard).
 * Those are the same, already loaded project: reloading it cleared the selection while its configuration stayed the
 * same, so nothing picked Project Home again. The project stayed on "Loading project…", then "We're coming back soon",
 * and the retry picked the first service's preview instead of Home (queue item 24).
 *
 * A same-id selection that reset its revision or configuration (picking the same project again in the picker) still
 * reloads.
 * @param {{ projectId: string|null, lastProjectId: string|null, revisionId: string|null, configuration: object|null }} input
 */
export function projectNeedsReload({ projectId, lastProjectId, revisionId, configuration }) {
  if (!projectId) { return false; }
  const sameProjectLoaded = projectId === lastProjectId && Boolean(revisionId) && Boolean(configuration) && !configuration.placeholder;
  return !sameProjectLoaded;
}
